"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _components = require("../../../components");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Hours = function Hours(_ref) {
  var primaryType = _ref.primaryType,
      secondaryType = _ref.secondaryType,
      hours = _ref.hours,
      label = _ref.label,
      isPreorderRequired = _ref.isPreorderRequired;
  var dayOfWeek = new Date().getDay();
  var todayHours = hours.find(function (hour) {
    return hour.days.includes(dayOfWeek);
  });
  var renderHoursUntilOpen = isPreorderRequired && typeof (todayHours === null || todayHours === void 0 ? void 0 : todayHours.hoursUntilOpen) === 'number';

  if (hours.length > 1) {
    return /*#__PURE__*/_react["default"].createElement(_components.Collapsable, {
      isOpen: false,
      title: /*#__PURE__*/_react["default"].createElement(_components.Text, {
        type: primaryType,
        style: {
          display: "block",
          marginBottom: "7px"
        }
      }, label)
    }, /*#__PURE__*/_react["default"].createElement(_components.Collapsable.Close, null, todayHours && /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: "flex",
        flexDirection: "column"
      }
    }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
      type: secondaryType
    }, "".concat(todayHours.text, ": ").concat(todayHours.hours)), renderHoursUntilOpen && /*#__PURE__*/_react["default"].createElement(_components.Text, {
      style: {
        color: "red"
      },
      type: secondaryType
    }, "(currently closed, opens in ", todayHours.hoursUntilOpen, " hours)"))), /*#__PURE__*/_react["default"].createElement(_components.Collapsable.Open, null, hours.map(function (i, index) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: index,
        style: {
          margin: "5px 0px"
        }
      }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
        type: secondaryType
      }, "".concat(i.text, ": ").concat(i.hours)));
    })));
  }

  if (todayHours) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_components.Text, {
      type: primaryType
    }, label)), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: "flex",
        flexDirection: "column"
      }
    }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
      type: secondaryType
    }, "".concat(todayHours.text, ": ").concat(todayHours.hours)), renderHoursUntilOpen && /*#__PURE__*/_react["default"].createElement(_components.Text, {
      style: {
        color: "red"
      },
      type: secondaryType
    }, "(currently closed, opens in ", todayHours.hoursUntilOpen, " hours)")));
  }

  return null;
};

var _default = Hours;
exports["default"] = _default;